export default __webpack_public_path__ + "7db9c983f1d490114cd91d8464afc275.svg";